var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgShape1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 399,
    viewBox: "0 0 610 399",
    fill: "#5E6E78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.387 -117.35C492.929 -204.094 393.11 -261.001 280 -261.001C97.746 -261.001 -50 -113.255 -50 68.9993C-50 95.5144 -46.8727 121.299 -40.9671 146.005L127.082 -22.0439C143.191 -38.1531 169.309 -38.1531 185.418 -22.0439L321.25 113.788L552.387 -117.35Z",
    fill: "#5E6E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.609 -39.8988L350.418 201.292C334.309 217.402 308.191 217.402 292.082 201.292L156.25 65.4606L-8.18604 229.897C48.2657 330.792 156.168 398.999 280 398.999C462.254 398.999 610 251.253 610 68.9993C610 30.8407 603.523 -5.80507 591.609 -39.8988Z",
    fill: "#5E6E78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape1);
export default __webpack_public_path__ + "static/media/bg-shape-1.f9c70acc8ec4fa4d56240212cfda6d84.svg";
export { ForwardRef as ReactComponent };